var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebLogins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.9843C10.6219 13.9843 9.5 12.8633 9.5 11.4843C9.5 10.1053 10.6219 8.98438 11.9999 8.98438C13.378 8.98438 14.4999 10.1053 14.4999 11.4843C14.4999 12.8633 13.378 13.9843 11.9999 13.9843ZM11.9999 10.4844C11.449 10.4844 11 10.9323 11 11.4843C11 12.0364 11.449 12.4843 11.9999 12.4843C12.5509 12.4843 12.9999 12.0364 12.9999 11.4843C12.9999 10.9323 12.5509 10.4844 11.9999 10.4844Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 19.9843C15.8361 19.9843 15.5001 19.6483 15.5001 19.2343V17.7343C15.5001 17.0452 14.9391 16.4844 14.2501 16.4844H9.75006C9.06103 16.4844 8.5 17.0452 8.5 17.7343V19.2343C8.5 19.6483 8.164 19.9843 7.75 19.9843C7.336 19.9843 7 19.6483 7 19.2343V17.7343C7 16.2172 8.23303 14.9844 9.75006 14.9844H14.2501C15.7671 14.9844 17.0001 16.2172 17.0001 17.7343V19.2343C17.0001 19.6483 16.6641 19.9843 16.2501 19.9843Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2499 22.9843H2.75006C1.23303 22.9843 0 21.7515 0 20.2344V3.73444C0 2.21741 1.23303 0.984375 2.75006 0.984375H21.2499C22.767 0.984375 24 2.21741 24 3.73444V20.2344C24 21.7515 22.767 22.9843 21.2499 22.9843ZM2.75006 2.48438C2.06104 2.48438 1.5 3.04541 1.5 3.73444V20.2344C1.5 20.9235 2.06104 21.4843 2.75006 21.4843H21.2499C21.939 21.4843 22.5 20.9235 22.5 20.2344V3.73444C22.5 3.04541 21.939 2.48438 21.2499 2.48438H2.75006Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 6.48438H0.75C0.335999 6.48438 0 6.14838 0 5.73438C0 5.32037 0.335999 4.98438 0.75 4.98438H23.25C23.664 4.98438 24 5.32037 24 5.73438C24 6.14838 23.664 6.48438 23.25 6.48438Z",
    fill: "#A6AAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLogins);
export default __webpack_public_path__ + "static/media/web-logins.1b52c2fc.svg";
export { ForwardRef as ReactComponent };